export const QUOTE_COPY_ACTION = {
  CLONE: 'clone',
  REVISION: 'revision',
};
